import { useRef } from "react";
import { Camera, Image as ImageIcon, X } from "lucide-react";
import { toast } from "sonner";

export const shrink = (file) => new Promise((resolve, reject) => {
  const im = new Image();
  im.onload = () => {
    const s = Math.min(1, 1280 / Math.max(im.width, im.height));
    const c = document.createElement("canvas");
    c.width = Math.round(im.width * s); c.height = Math.round(im.height * s);
    c.getContext("2d").drawImage(im, 0, 0, c.width, c.height);
    URL.revokeObjectURL(im.src);
    resolve(c.toDataURL("image/jpeg", 0.85));
  };
  im.onerror = reject;
  im.src = URL.createObjectURL(file);
});

export const PhotoPicker = ({ photo, setPhoto, required, note }) => {
  const ref = useRef(null);
  const cam = useRef(null);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) return toast.error("Elige una imagen");
    try { setPhoto(await shrink(file)); } catch { toast.error("No hemos podido leer esa foto. Prueba con otra en JPG o PNG."); }
  };
  return (
    <div data-testid="dx-photo">
      <p className="font-display text-lg font-bold text-[#0B1D3A]">Foto de tu caballo {!required && <span className="text-sm font-normal text-slate-500">(opcional, recomendada)</span>}</p>
      <input ref={ref} type="file" accept="image/*" onChange={pick} className="hidden" data-testid="dx-photo-input" />
      <input ref={cam} type="file" accept="image/*" capture="environment" onChange={pick} className="hidden" data-testid="dx-photo-camera-input" />
      {photo ? (
        <div className="relative mt-2">
          <img src={photo} alt="Tu caballo" className="w-full max-h-64 object-cover rounded border border-slate-200" data-testid="dx-photo-preview" />
          <button type="button" onClick={() => setPhoto(null)} className="absolute top-2 right-2 bg-white/90 hover:bg-white rounded-full p-1.5 text-[#0B1D3A]" data-testid="dx-photo-remove"><X size={16} /></button>
        </div>
      ) : (
        <div className="mt-2 border-2 border-dashed border-[#93C5FD] bg-[#EFF6FF] rounded p-4">
          <div className="grid grid-cols-2 gap-3">
            <button type="button" onClick={() => ref.current?.click()} data-testid="dx-photo-button"
              className="flex flex-col items-center gap-1 bg-white border border-[#93C5FD] hover:border-[#2563EB] rounded py-4 text-[#0B1D3A] font-bold text-sm transition-colors">
              <ImageIcon size={24} /> Subir de la galería
            </button>
            <button type="button" onClick={() => cam.current?.click()} data-testid="dx-photo-camera-button"
              className="flex flex-col items-center gap-1 bg-white border border-[#93C5FD] hover:border-[#2563EB] rounded py-4 text-[#0B1D3A] font-bold text-sm transition-colors">
              <Camera size={24} /> Hacer una foto
            </button>
          </div>
          <p className="text-xs text-slate-500 text-center mt-3">Vista lateral completa, la zona afectada o los cascos</p>
        </div>
      )}
      <p className="text-[11px] text-slate-500 mt-1.5">{note || "La foto solo se usa para este análisis y no se guarda."}</p>
    </div>
  );
};
